import { suppliesInventoryConfigIdFormat } from "@redotech/redo-marketplace-id";
import * as z from "zod";

export const setSuppliesInventoryLevel = {
  name: "setSuppliesInventoryLevel" as const,
  input: z.object({
    configId: suppliesInventoryConfigIdFormat.schema,
    /** "set" makes `amount` the new on-hand count; "adjust" adds it (may be negative). */
    mode: z.enum(["set", "adjust"]).nullish(),
    amount: z.number().int().nullish(),
    /** @deprecated Use mode "set" with amount. Kept for clients mid-deploy. */
    targetUnits: z.number().int().min(0).nullish(),
    note: z.string().nullish(),
  }),
  output: z.object({ availableInventory: z.number().int() }),
};
